import React from 'react';
import { SideBar, TopBar } from '../components';

const DashboardLayout = ({ children, showLayout }) => (
  <>
    {showLayout && <SideBar />}
    {showLayout && <TopBar />}
    {children}
  </>
);

export default DashboardLayout;